/*
 * Recently viewed products.
 *
 * Reads the product ids saved by snippets/recently-viewed-tracker.liquid from
 * localStorage, then fetches server-rendered product cards via Shopify's Search
 * section-rendering API (one request) and injects them into the grid, preserving
 * most-recent-first order. The whole section stays hidden until cards are ready,
 * so there is never an empty "Recently viewed" block.
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() { 
      this.sectionId = this.dataset.sectionId;
      this.max = parseInt(this.dataset.productsToShow, 10) || 10;
      this.currentId = this.dataset.currentProductId
        ? parseInt(this.dataset.currentProductId, 10)
        : null;
      this.grid = this.querySelector('#RecentlyViewed-grid-' + this.sectionId);

      if (this.grid) this.render();
    }

    getIds() {
      var list = [];
      try {
        list = JSON.parse(localStorage.getItem('caycollective:recently-viewed')) || [];
      } catch (e) {
        list = [];
      }

      var currentId = this.currentId;
      return list
        .filter(function (id) { return id && id !== currentId; })
        .slice(0, this.max);
    }

    render() {
      var ids = this.getIds();
      if (!ids.length) return; // no history -> section stays hidden

      var query = ids
        .map(function (id) { return 'id:' + id; })
        .join(' OR ');
      var url =
        '/search?type=product&q=' +
        encodeURIComponent(query) +
        '&section_id=' +
        this.sectionId;

      var self = this;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fetched = doc.getElementById('RecentlyViewed-grid-' + self.sectionId);
          if (!fetched || !fetched.children.length) return;

          self.grid.innerHTML = fetched.innerHTML;
          self.reorder(ids);
          self.hidden = false;
        })
        .catch(function () {});
    }

    // Search results ignore our recency order, so re-sort by the id order.
    reorder(ids) {
      var grid = this.grid;
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-product-id]'));
      items
        .sort(function (a, b) {
          return (
            ids.indexOf(parseInt(a.dataset.productId, 10)) -
            ids.indexOf(parseInt(b.dataset.productId, 10))
          );
        })
        .forEach(function (item) { grid.appendChild(item); });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
